module.exports = __webpack_public_path__ + "static/img/paehtz.20c30a3.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/personas/paehtz.jpg
// module id = 492
// module chunks = 11